<template>
  <LocationMarkerIcon class="h-4 w-4" />
</template>

<script>
import { LocationMarkerIcon } from '@heroicons/vue/outline'

export default {
  components: { LocationMarkerIcon }
}
</script>

<style>

</style>
